import { render, staticRenderFns } from "./SchoolYearDateInput.vue?vue&type=template&id=d501e1f2&"
import script from "./SchoolYearDateInput.vue?vue&type=script&lang=js&"
export * from "./SchoolYearDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports